import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import ElementUI from "element-ui";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import jwt from "jsonwebtoken";
import locale from "element-ui/lib/locale/lang/zh-TW";
import VueGtm from '@gtm-support/vue2-gtm';
Vue.config.performance = true;
Vue.use(CoreuiVue);
//Vue.use(ElementUI)
Vue.use(ElementUI, { locale });
Vue.prototype.$log = console.log.bind(console);
Vue.use(VueGtm, {
  id: 'GTM-NS4RM5S', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  enabled: true,
  debug: false 
});
const access_token = localStorage.getItem("access_token");
if (access_token) {
  const decoded = jwt.decode(access_token);
  store.commit("auth/updateByToken", { access_token, decoded });

  //NOTE: always to refresh token to reflect possible recent roles changes
  store.dispatch("auth/refresh").
  catch(err => {
    console.log(`refresh: err = ${err.message}`);
    router.push({ name: "Login" });
  });
}

router.beforeEach((to, _, next) => {
  //Loading.service({ fullscreen: true })
  if (store.state.auth.isSignIn || to.name === "Login") {

    //console.log(`beforeEach: to.path = ${JSON.stringify(to.path)} to.meta = ${JSON.stringify(to.meta)}`)
    //to.matched.forEach(record =>
      //record && console.log(`beforeEach: path = ${JSON.stringify(record.path)} meta = ${JSON.stringify(record.meta)}`)
    //);

    const requiredRoles = to.meta.roles;

    if (requiredRoles && requiredRoles.length > 0) {
      const intersection = requiredRoles.filter( role => store.state.auth.roles.includes(role));
      if (intersection.length > 0) {
        next();
      } else {
        next("/pages/404");
      }
    } else {
      next();
    }
  } else {
    next("/pages/login");
  }
});

new Vue({
  el: "#app",
  router,
  store,
  icons,
  template: "<App/>",
  components: {
    App,
  },
});
